export default (node, x) => window.getComputedStyle(node, x)
